import {toggleAngleIcon} from './dropdown';
import {getContainer} from './getContainer';
import {GetLocalStorage, SetLocalStorage} from "../core/functions";

export function InitCollapse(container = document) {
    if (container === document && isDifferentFromPreviousPage()) {
        clearCollapseState();
    }

    container = getContainer(container);
    const collapseButtons = container.querySelectorAll('[data-toggle="collapse"]');

    collapseButtons.forEach((button) => {
        const targetId = button.getAttribute('data-target');

        // Valideer of targetId bestaat en geldig is
        if (!targetId || targetId.trim() === '' || targetId.trim() === '#') {
            return; // Skip deze button
        }

        // Zoek binnen de container, niet in het hele document
        let collapseBody;
        try {
            collapseBody = container.querySelector(`#${targetId}`) || document.getElementById(targetId);
        } catch (e) {
            // Ongeldige selector, skip deze button
            return;
        }

        // Check of het collapse element bestaat
        if (!collapseBody) {
            return; // Skip deze button
        }

        //-- Only if tech-info
        if (collapseBody.hasAttribute('data-tech')) {
            let css = window.getComputedStyle(collapseBody, null);
            let size = collapseBody.clientHeight;

            //-- Check if the height of the collapse-element is smaller or equal then min-height-property
            if (parseInt(css.getPropertyValue("min-height")) >= size) {
                //-- Remove the collapse-specific class-names
                collapseBody.classList.forEach(name => {
                    if (name.includes("!min-h")) {
                        collapseBody.classList.remove(name);
                    }
                });
                collapseBody.classList.remove('show', 'collapse', 'partial-collapse');

                //-- Display-none on the show more button
                button.classList.add("hidden");
                return;
            }
        }

        // Check voor data-default-open attribuut (alleen gebruikt voor specificatie secties)
        const defaultOpen = collapseBody.getAttribute('data-default-open');
        const isDesktop = window.innerWidth >= 1024; // lg breakpoint

        // Als het element data-default-open="desktop" heeft en we zijn op desktop
        if (defaultOpen === 'desktop' && isDesktop && !hasCollapseState(collapseBody.id, button)) {
            // Zet standaard open
            collapseBody.classList.add('show');
            // Draai chevron icon met de rotate-180 class
            const icon = button.querySelector('i[class*="fa-angle-"]');
            if (icon) {
                icon.classList.add('rotate-180');
            }
        }

        registerCollapse(collapseBody, button);

        button.addEventListener('click', () => {
            handleCollapse(button);
        });
    });
}

export const handleCollapse = button => {
    const targetId = button.getAttribute('data-target');

    // Valideer of targetId bestaat en geldig is
    if (!targetId || targetId.trim() === '' || targetId.trim() === '#') {
        return; // Stop de functie
    }

    // Find within the button's container context (for bundle techinfo/specs)
    const container = button.closest('[id^="toggleTech_"], [id^="toggleDesc_"]') || document;
    let collapseBody;
    try {
        collapseBody = container.querySelector(`#${targetId}`) || document.getElementById(targetId);
    } catch (e) {
        // Ongeldige selector, stop de functie
        return;
    }

    // Check of het collapse element bestaat
    if (!collapseBody) {
        return; // Stop de functie
    }

    let collapseOpen = collapseBody.classList.contains('show');

    // Alleen hoogte herberekenen als --calc-height nog niet gezet is
    // Dit voorkomt onnodige reflows bij elke klik
    const calcHeight = collapseBody.style.getPropertyValue('--calc-height');
    if (!calcHeight || calcHeight === '0px') {
        const tempShow = !collapseBody.classList.contains('show');
        if (tempShow) {
            // Zet transition tijdelijk uit om flikkering te voorkomen
            const originalTransition = collapseBody.style.transition;
            collapseBody.style.transition = 'none';
            collapseBody.classList.add('show');

            // Force reflow
            void collapseBody.offsetHeight;

            const currentHeight = collapseBody.scrollHeight;
            collapseBody.style.setProperty('--calc-height', currentHeight + 'px');

            collapseBody.classList.remove('show');
            // Force reflow
            void collapseBody.offsetHeight;

            // Zet transition weer aan
            collapseBody.style.transition = originalTransition;
        } else {
            const currentHeight = collapseBody.scrollHeight;
            collapseBody.style.setProperty('--calc-height', currentHeight + 'px');
        }
    }

    if (button.hasAttribute('data-store-state')) {
        storeCollapseState(button.getAttribute('data-target'), !collapseOpen);
    }

    toggleAngleIcon(button);
    replaceButtonLang(button);
    toggleCollapse(collapseBody, collapseOpen);
    if (collapseOpen && button.getAttribute('data-scroll-to')) {
        scrollTo(button);
    }
};

const scrollTo = (button) => {
    let scrollToElement = document.getElementById(button.getAttribute('data-scroll-to'));
    if (scrollToElement) {
        scrollToElement.scrollIntoView();
    }
};

export const registerCollapse = (collapse, button = false) => {
    if (!isCollapseNeeded(collapse)) {
        if (button) {
            button.classList.add('!hidden');
        }
        return true;
    }

    setMaxHeight(collapse);


    if (collapse.hasAttribute('data-delay-collapse')) {
        toggleCollapse(collapse, true);
    }

    // Check if the collapse state is stored in local storage then close the collapse
    if (hasCollapseState(collapse.id, button)) {
        toggleCollapse(collapse, !getCollapseState(collapse.id));

        if (collapse.id && button) {
            toggleAngleIcon(button);
        }
    }
};

const setMaxHeight = (calcTarget) => {
    resize(calcTarget);
    window.addEventListener('resize', () => resize(calcTarget));
    window.addEventListener('load', () => resize(calcTarget));
};


const resize = calcTarget => {
    // Bereken altijd de hoogte, ook als het element niet open is
    // Dit is nodig voor het correct openklappen na bundel switch
    const wasOpen = calcTarget.classList.contains('show');
    const tempShow = !wasOpen;

    if (tempShow) {
        calcTarget.classList.add('show');
    }

    let size = calcTarget.scrollHeight + 'px';
    if (calcTarget.style.getPropertyValue('--calc-height') !== size) {
        calcTarget.style.setProperty('--calc-height', size);
    }

    // Alleen max-height zetten als het element ECHT open was (niet tijdelijk)
    if (wasOpen) {
        calcTarget.style.maxHeight = 'max-content';
    }

    if (tempShow) {
        calcTarget.classList.remove('show');
    }
};

const replaceButtonLang = button => {
    const replaceLang = button.getAttribute('data-lang-toggle');
    let span = button.querySelector('span');

    if (span && replaceLang) {
        const currentLang = span.innerText;

        if (replaceLang) {
            span.innerText = replaceLang;
            button.setAttribute('data-lang-toggle', currentLang);
        }
    }
};

export const toggleCollapse = (collapseBody, toggle) => {
    if (toggle) {
        // Dichtklappen: verwijder show class voor CSS animatie
        collapseBody.style.removeProperty('max-height');
        collapseBody.classList.remove('show');

    } else {
        // Openklappen: --calc-height is al gezet door handleCollapse
        // Voeg show class toe voor CSS animatie naar open state
        collapseBody.classList.add('show');

        // Na animatie: zet max-height op max-content zodat content kan groeien
        setTimeout(() => {
            if (collapseBody.classList.contains('show')) {
                collapseBody.style.maxHeight = 'max-content';
            }
        }, 300);
    }
};

function storeCollapseState(collapseName, open) {
    const collapseState = getCollapseStateObject();

    collapseState[collapseName] = open;

    SetLocalStorage('collapseState', JSON.stringify(collapseState));
}

function hasCollapseState(collapseName, button = false) {
    if (button && !button.hasAttribute('data-store-state')) {
        return false;
    }

    const collapseState = getCollapseStateObject();

    return collapseState.hasOwnProperty(collapseName);
}

function getCollapseState(collapseName) {
    const collapseState = getCollapseStateObject();

    return collapseState[collapseName];
}


function getCollapseStateObject() {
    let collapseState = GetLocalStorage('collapseState');

    if (collapseState === '') {
        collapseState = {};
    } else {
        collapseState = JSON.parse(collapseState);
    }

    return collapseState;
}

function isCollapseNeeded(collapse) {
    if (collapse.classList.contains('show')) {
        const size = collapse.clientHeight;
        const minHeight = parseInt(window.getComputedStyle(collapse, null).getPropertyValue("min-height"));
        const tolerance = 10;  // wiggle room in pixels

        return (minHeight + tolerance) < size;
    }

    return true;
}

function clearCollapseState() {
    SetLocalStorage('collapseState', '');
}

function isDifferentFromPreviousPage() {
    const previousPage = document.referrer;
    const currentPage = window.location.href;

    if (previousPage?.length > 0 && currentPage?.length > 0) {
        // Check if the page was reloaded
        if (window.performance && window.performance.getEntriesByType) {
            const navigationEntries = window.performance.getEntriesByType('navigation');
            if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
                return false;  // It's a different "visit" since the page was reloaded
            }
        }

        return getBaseUrl(previousPage) !== getBaseUrl(currentPage);
    }
}

function getBaseUrl(url) {
    const urlObj = new URL(url);
    // Remove the search (query parameters) part
    urlObj.search = '';
    return urlObj.toString();
}

// Export functies naar window voor gebruik in andere modules
window.InitCollapse = InitCollapse;
window.registerCollapse = registerCollapse;
window.handleCollapse = handleCollapse;
window.toggleAngleIcon = toggleAngleIcon;
window.toggleCollapse = toggleCollapse;